import axios from "axios";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { parseTaskModel } from "../../task/model";

import { PpqDeclarationReview } from "./models";

const buildUrl = (customerId: string, ohCaseId: string, taskId: string) => `/api/customer/${customerId}/ohCase/${ohCaseId}/task/${taskId}/ppqDeclarationReview`;

const load = async (customerId: string, ohCaseId: string, taskId: string) => {
    const result = await axios.get<PpqDeclarationReview>(buildUrl(customerId, ohCaseId, taskId));
    return result.data;
};

const submit = async (customerId: string, ohCaseId: string, taskId: string, notes: string) => {
    const result = await axios.post<TaskModel>(buildUrl(customerId, ohCaseId, taskId), { notes });
    return parseTaskModel(result.data);
};

export const PpqDeclarationReviewApi = { load, submit };
